import request from '@/utils/request'

const preUrl = "/concat";
export const reqListConcat = (data) => {
    return request({
        url: preUrl + '/list', method: 'post', data
    })
}
